module.exports = __webpack_public_path__ + "img/download-icon.6eb663a9.svg";